import {z} from 'zod'

import {
  BlockChapterOpenerFragment,
  CreateOrUpdateBlockChapterOpenerDocument,
} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {MediaLibraryFileType} from '../../../../MediaLibrary/types'

import type {BlockChapterOpenerInput, CreateOrUpdateBlockChapterOpenerMutation,
  XcNwBlock_BlockChapterOpenerType_Fragment} from '@sdox/api'

type UpdateChapterOpenerValidatorSchema = z.infer<typeof updateChapterOpenerValidatorSchema>

const updateChapterOpenerValidatorSchema = z.object({
  data: z.object({
    count: z.union([z.number().min(1).max(999999999999).nullish(), z.nan()]),
    title: z.string().min(1).max(32),
    media: z.object({
      fileHash: z.string().min(1),
    }),
    mediaMobile: z.object({
      fileHash: z.string().min(1),
    }).nullish(),
  }),
  meta: updateMetaSchema,
})

export const chapterOpenerConfig = createFormConfig<
  UpdateChapterOpenerValidatorSchema,
  CreateOrUpdateBlockChapterOpenerMutation,
  BlockChapterOpenerInput,
  XcNwBlock_BlockChapterOpenerType_Fragment
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockChapterOpenerDocument,
  },
  fieldMapper: (fieldValues) => ({
    title: fieldValues.data.title,
    count: fieldValues.data.count ?? null,
    fileHash: fieldValues.data.media.fileHash,
    fileHashMobile: fieldValues.data.mediaMobile?.fileHash,
  }),
  validatorSchema: updateChapterOpenerValidatorSchema,
  inputFields: [
    {
      label: 'Count',
      fieldName: 'data.count',
      inputType: 'number',
      defaultValue: undefined,
      required: false,
    },
    {
      label: 'Title',
      fieldName: 'data.title',
      inputType: 'text',
      defaultValue: '',
      required: true,
    },
    {
      label: 'Bild oder Video - Desktop',
      fieldName: 'data.media',
      inputType: 'file',
      defaultValue: '',
      required: true,
      aspectRatio: '3/2',
      fileTypes: [
        MediaLibraryFileType.Image,
        MediaLibraryFileType.Video,
      ],
    },
    {
      label: 'Bild oder Video - Mobile',
      fieldName: 'data.mediaMobile',
      inputType: 'file',
      defaultValue: '',
      required: false,
      description: 'Ist kein Element für Mobile ausgewählt, wird stattdessen das Desktop Element im 2:3 Format angezeigt.',
      aspectRatio: '2/3',
      fileTypes: [
        MediaLibraryFileType.Image,
        MediaLibraryFileType.Video,
      ],
    },
  ],
  getDefaultValues: (block) => {
    return {
      data: {
        count: block.count,
        title: block.title,
        media: block.chapterOpenerMedia,
        mediaMobile: block.chapterOpenerMediaMobile,
      },
    }
  },
})
